export default __webpack_public_path__ + "images/models/a50585ee8f1562037c8fc3e4995837a5.glb";